import { Add } from "@mui/icons-material";
import { useContext } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router";
import { NavigationList } from "../../../components/NavigationList";
import { StyledFloatingActionButton } from "../../../components/StyledFloatingActionButton";
import { searchContext } from "../../../layout/MainLayout";
import { Logger } from '../../../utils/Logger';

export const ProgrammesPage = () => {
    Logger.debug('COMPONENT', "ProgrammesPage rendered");
    const params = useParams();
    const bailleurId = parseInt(params.bailleurId || "0", 10);
    const data = useLoaderData() as {
        programmes: ReadonlyArray<string>
    };
    Logger.debug('COMPONENT', "ProgrammesPage - bailleurId:", bailleurId, "programmes:", data.programmes.length);
    const navigate = useNavigate();
    const handleAddClick = () => {
        navigate(`../new?bailleur=${bailleurId}`);
    };
    const context = useContext(searchContext);
    const search = context?.search.trim().toLocaleLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");

    let programmes = data.programmes;
    programmes = search ? programmes.filter(x => x && x.toLocaleLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").indexOf(search) >= 0) : programmes;
    return <>
        <NavigationList items={programmes.map(x => {
            return {
                text: x || "- Hors programme -",
                path: `../${bailleurId}/logements/${x ? encodeURIComponent(x) : ""}`,
            };
        })} />
        <StyledFloatingActionButton color="primary" aria-label="ajouter" onClick={handleAddClick}>
            <Add />
        </StyledFloatingActionButton>
    </>;
};
